import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import Loading from '../../common/Loading';
import Error from '../../common/Error';
import KPIAverageScrapReturnListItem from './KPIAverageScrapReturnListItem';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function KPIAverageScrapReturn(props) {
    //console.debug("RTS Break KPIAverageScrapReturn");

    const {user, sessionCustomer, userAuthToken, apiRoot} = useSessionContext();
    const history = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const [repoRows, setRepoRows] = useState([]);

    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/Analytics/GetAverageScrapReturnKPI";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token}}
        )
        .then(response => {
            if (response.data) {
                setRepoRows(response.data);
                setIsLoading(false);
            }
        })
        .catch(error => {
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    },[apiRoot, userAuthToken.token]); 


    useEffect(() => {
        fetchData(sessionCustomer.customer);
    }, [sessionCustomer]); 


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return (
        <Container maxWidth="sm" sx={{border:1, borderRadius:2}}>
            <Box sx={{textAlign:"center"}}>
                <Typography variant="h6">Avg. Scrap Return</Typography>
            </Box>
            {/* <Box sx={{textAlign:"center"}}>
                <Typography variant="h5">{repoRows.length}</Typography>
            </Box> */}
            <Box sx={{px:2, textAlign:"center", maxHeight:"300px", overflowY:"scroll"}}>
                <Table size="small" sx={{maxHeight:"300px", overflow:"scroll"}}>
                    <TableHead sx={{width:'100%'}}>
                    </TableHead>                 
                    <TableBody>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell align="right" sx={{width:"75px", fontWeight:'bold', fontSize:'.6em', textAlign:'center'}}>12 Month</TableCell>
                            <TableCell align="right" sx={{width:"75px", fontWeight:'bold', fontSize:'.6em', textAlign:'center'}}>6 Month</TableCell>
                        </TableRow>                        
                        {repoRows.map((row, idx) => (<KPIAverageScrapReturnListItem key={idx} data={row} />))}
                    </TableBody>
                </Table>
            </Box>
        </Container>
    );
}
